<template>
    <div>
        <v-row dense>
           <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card
                    class="mx-auto pa-3"
                    outlined
                    min-height="120px"
                    @click="rentalMonthlyFeeAlertReport({ payment_date_null: true })"  
                >
                    <v-row>
                        <v-col cols="3">
                           <v-icon x-large color="red">mdi-account-cash-outline</v-icon>
                        </v-col>
                        <v-col class="text-left" cols="9"> 
                            <div>
                                <div class="text-h6" style="color: black;">Aluguel vencido </div>
                                <div class="text-h4 mt-3" style="color: red;">{{ alerts.payment_date_alert }}</div>
                            </div>
                        </v-col>
                    </v-row>
                    
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card
                    class="mx-auto pa-3"
                    outlined
                    min-height="120px"
                    @click="rentalMonthlyFeeAlertReport({ transfer_owner_date_null: true })" 
                >
                    <v-row>
                        <v-col cols="3">
                           <v-icon x-large color="orange">mdi-account-cash-outline</v-icon>
                        </v-col>
                        <v-col class="text-left" cols="9"> 
                            <div>
                                <div class="text-h6" style="color: black;">Repasse pendente</div>
                                <div class="text-h4 mt-3" style="color: orange;">{{ alerts.transfer_owner_date_alert }}</div>
                            </div>
                        </v-col>
                    </v-row>
                    
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card
                    class="mx-auto pa-3"
                    outlined
                    min-height="120px"
                    @click="rentalMonthlyFeeAlertReport({ update_value_yes: true })" 
                >
                    <v-row>
                        <v-col cols="3">
                           <v-icon x-large color="green">mdi-account-cash-outline</v-icon>
                        </v-col>
                        <v-col class="text-left" cols="9"> 
                            <div>
                                <div class="text-h6" style="color: black;">Atualização aluguel</div>
                                <div class="text-h4 mt-3" style="color: green;">{{ alerts.update_value_alert }}</div>
                            </div>
                        </v-col>
                    </v-row>
                    
                </v-card>
            </v-col>
            <v-col v-if="alerts.total_alerts && alerts.total_alerts > 0" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card
                    class="mx-auto pa-3"
                    outlined
                    min-height="120px"
                    @click="rentalMonthlyFeeAlertReport({ total_alerts: true })" 
                >
                    <v-row>
                        <v-col cols="3">
                           <v-icon x-large color="red">mdi-chat-alert-outline</v-icon>
                        </v-col>
                        <v-col class="text-left" cols="9"> 
                            <div>
                                <div class="text-h6" style="color: black;">Alertas</div>
                                <div class="text-h4 mt-3" style="color: red;">{{ alerts.total_alerts }}</div>
                            </div>
                        </v-col>
                    </v-row>
                    
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <v-card
                    class="mx-auto pa-3"
                    outlined
                    min-height="120px"
                    @click="rentalMonthlyFeeAlertReport({ contract_alert: true })" 
                >
                    <v-row>
                        <v-col cols="3">
                           <v-icon x-large color="blue">mdi-file-document-edit-outline</v-icon>
                        </v-col>
                        <v-col class="text-left" cols="9"> 
                            <div>
                                <div class="text-h6" style="color: black;">Contratos a vencer</div>
                                <div class="text-h4 mt-3" style="color: blue;">
                                    {{ alerts.contract_alert }}
                                    <span class="text-button">
                                         (30 dias antes)
                                    </span>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    
                </v-card>
            </v-col>
        </v-row>    

        <v-row v-if="items && items.length > 0">
            <v-col cols="12">
                <v-btn class="mb-3" @click.prevent="rentalRentalMonthlyFeeAlertReportExport(params)" small :class="$css_button" color="excel" dark depressed>exportar excel</v-btn>  

                <v-card
                    class="mx-auto pa-3"
                    outlined
                    min-height="60px"
                >
                    <v-data-table
                        :headers="headers"
                        :items="items"
                    >
                        <template v-slot:[`item.codigo`]="{ item }"> 
                            <span :class="$css_report_list">{{ item.codigo }}</span>
                        </template>

                        <template v-slot:[`item.endereco`]="{ item }"> 
                            <div class="pa-2">
                                <span :class="$css_report_list + ' font-weight-medium'">
                                    {{ item.endereco }}
                                    <span v-if="item.numero">, {{ item.numero }}</span>
                                    <span v-if="item.apartamento"> APTO:  {{ item.apartamento }}</span>
                                    <span v-if="item.complemento"> Compl:  {{ item.complemento }}</span>
                                </span>
                                <div :class="$css_report_list + ' mt-2 '">
                                    <div>
                                        <span class="font-weight-medium">Proprietários:</span> 
                                        <span v-if="item.json_rental_owners && item.json_rental_owners.length > 0">
                                            <span v-for="(cl, index) in item.json_rental_owners" :key="cl.id">
                                                {{ cl.nome }}
                                                <span v-if="cl.telefone || cl.email">
                                                    (
                                                    <span class="mr-2" v-if="cl.telefone">
                                                        Tel: {{ cl.telefone }}
                                                    </span>
                                                    <span class="mr-2" v-if="cl.email">
                                                        e-mail: {{ cl.email }}
                                                    </span>
                                                    )
                                                </span>
                                                <span v-if="(index + 1) < item.json_rental_owners.length">, </span>
                                            </span>
                                        </span>
                                    </div>

                                    <div>
                                        <span class="font-weight-medium">Locatários:</span> 
                                        <span v-if="item.json_rental_tenants && item.json_rental_tenants.length > 0">
                                            <span v-for="(cl, index) in item.json_rental_tenants" :key="cl.id">
                                                {{ cl.nome }}
                                                <span v-if="cl.telefone || cl.email">
                                                    (
                                                    <span class="mr-1" v-if="cl.telefone">
                                                        Tel: {{ cl.telefone }}
                                                    </span>
                                                    <span class="mr-1" v-if="cl.email">
                                                        e-mail: {{ cl.email }}
                                                    </span>
                                                    )
                                                </span>
                                                <span v-if="(index + 1) < item.json_rental_tenants.length">, </span>
                                            </span>
                                        </span>

                                    </div>

                                    <div v-if="item.pasta">
                                        <span class="font-weight-medium">Pasta:</span>
                                        {{ item.pasta }} 
                                    </div>

                                </div>
                            </div>     
                        </template>

                        <template v-slot:[`item.total`]="{ item }"> 
                            <v-card-actions>
                                <v-btn class="mt-4" @click.prevent="showMonthlyFees(item)" small :class="$css_button" color="secondary" depressed>
                                    Mensalidades 
                                </v-btn>

                                <v-tooltip top v-if="show_message.contract_alert">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn  icon @click.prevent="sendAlert(item)" class="ml-8">
                                            <v-icon v-bind="attrs" v-on="on" color="gray">mdi-email-fast-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>
                                        <span>Baixar Alerta de Renovação</span>
                                    </span>
                                </v-tooltip>    
                            </v-card-actions>
                        </template> 

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>    

        <!-- Dialog -->
        <v-dialog 
            v-if="rental_item && rental_item != ''"
            v-model="dialog.showMonthlyFees" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>    

            <v-card class="d-print-none" color="white">
                <v-card-title class="text-h5">
                    Contrato
                    <span v-if="rental_item.codigo" class="ml-2">- Código {{rental_item.codigo}} </span>
                    <span v-if="rental_item.codigo" class="ml-6 text-subtitle-1"> 
                        <div>
                            <span class="font-weight-medium">Endereço:</span>     
                            {{rental_item.endereco}} 
                            <span v-if="rental_item.numero">, {{ rental_item.numero }}</span>
                            <span v-if="rental_item.apartamento"> APTO {{ rental_item.apartamento }}</span>
                            <span v-if="rental_item.complemento"> {{ rental_item.complemento }}</span>
                        </div>
                    </span>

                    <span v-if="rental_item.codigo" class="ml-6 text-subtitle-1">                         
                        <div>
                            <span class="font-weight-medium">Proprietários:</span> 
                            <span v-if="rental_item.json_rental_owners && rental_item.json_rental_owners.length > 0">
                                <span v-for="(cl, index) in rental_item.json_rental_owners" :key="cl.id">
                                    {{ cl.nome }}
                                    <span v-if="(index + 1) < rental_item.json_rental_owners.length">, </span>
                                </span>
                            </span>
                        </div>
                    </span>                        

                    <span v-if="rental_item.codigo" class="ml-6 text-subtitle-1">     
                        <div>
                            <span class="font-weight-medium">Locatários:</span> 
                            <span v-if="rental_item.json_rental_tenants && rental_item.json_rental_tenants.length > 0">
                                <span v-for="(cl, index) in rental_item.json_rental_tenants" :key="cl.id">
                                    {{ cl.nome }}
                                    <span v-if="(index + 1) < rental_item.json_rental_tenants.length">, </span>
                                </span>
                            </span>
                        </div>

                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showDialog('showMonthlyFees')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="monthly_headers"
                                :items="rental_item.rental_monthly_fees_json"
                            >
                                <template v-slot:[`item.due_date`]="{ item }">
                                    <v-chip
                                        :color="item ? statusDueDate(item): null"
                                        label
                                    >
                                        {{ formatDate(item.due_date) }}
                                    </v-chip>               
                                </template>

                                <template v-slot:[`item.payment_date`]="{ item }">
                                    <v-chip
                                        v-if="item.payment_date"
                                        label
                                    >
                                        {{ formatDate(item.payment_date) }}
                                    </v-chip>
                                </template>

                                <template v-slot:[`item.transfer_owner_date`]="{ item }">
                                    <v-chip
                                        v-if="item.transfer_owner_date"
                                        label
                                    >
                                        {{ formatDate(item.transfer_owner_date) }}
                                    </v-chip>
                                </template>

                                <template v-slot:[`item.total`]="{ item }">
                                    {{ totalTenant(item.json_rental_monthly_fee_values) | toCurrency }}
                                </template>

                                <template v-slot:[`item.adm`]="{ item }">
                                        {{ totalAdm(item.json_rental_monthly_fee_values) | toCurrency }}
                                </template>

                                <template v-slot:[`item.repasse`]="{ item }">
                                        {{ totalOwner(item.json_rental_monthly_fee_values) | toCurrency }}
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                    
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <router-link :to="{ 
                                                name: 'admin.rentals.index', 
                                                params: {
                                                    rental_id: rental_item.id,
                                                    rental_monthly_fee_id: item.id                          
                                                } 
                                            }">
                                                <v-btn icon class="ml-8">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                                                </v-btn>
                                            </router-link>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    
                                    
                                    <v-tooltip top>
                                        <template v-if="item.update_value && item.update_value == 'Sim'" v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                class="ml-6"
                                                v-bind="attrs"
                                                v-on="on"
                                                color="red"
                                            >
                                                mdi-update
                                            </v-icon>
                                        </template>
                                        <span>Alerta de atualização de aluguel</span>
                                    </v-tooltip> 
                                </template>   

                            </v-data-table>
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->

        <!-- Dialog send email -->
        <v-dialog
            v-model="dialog.send_email_contract"
            width="500"
        >
            <v-card class="d-print-none pa-3">
                <!--v-alert 
                    text
                    dense
                    color="orange"          
                    icon="mdi-alert-outline"    
                >
                    <div>
                        <div class="black--text">Para que o sistema envie o e-mail, é necessário configurar o texto da mensagem e definir o locatário que receberá o aviso.</div>
                        <div class="black--text mt-3">Clique em 'Confirmar envio' para concluir o envio do alerta sobre mensalidade(s) em aberto.</div>
                    </div>
                </v-alert-->

                <div v-if="sendItem" class="text-left ma-4">
                    <div>
                        Codigo: {{ sendItem.codigo }}
                    </div>
                    <div>
                        Pasta: {{ sendItem.pasta }}
                    </div>
                    <div>
                        Data final do contrato: {{ sendItem.fim_contrato }}
                    </div>
                    <div>
                        Reajuste: {{ sendItem.reajuste }} meses
                    </div>
                </div>

                <!--v-btn
                    x-large
                    block
                    dark
                    color="primary"
                    @click="confirmSendAlert()"
                    :class="$css_button_large"
                >
                     Confirmar envio
                </v-btn-->

                <v-btn
                    class="mt-4"
                    x-large
                    block
                    dark
                    color="secondary"
                    @click="downloadPdfAlert()"
                    :class="$css_button_large"
                >
                     Mensagem em PDF
                </v-btn>
            </v-card>
        </v-dialog>
        <!-- End Dialog send email -->
        
    </div>
</template>

<script>
export default {
    created() {
        this.rentalMonthlyFeeAlerts()
    },

    data () {
        return {
            rental_item: {},
            params: {},
            alert_selected_color: '#F3E5F5',

            dialog: {
                showMonthlyFees: false,
                send_email_contract: false
            },

            alert_colors: {
                payment_date_alert: 'white',
                transfer_owner_date_alert: 'white',
                update_value_alert: 'white'
            },

            alerts: {
                payment_date_alert: 0,
                transfer_owner_date_alert: 0,
                update_value_alert: 0
            },

            headers: [
                { text: 'CODIGO', value: 'codigo' },
                { text: 'DETALHES', value: 'endereco' },
                { text: 'MENSALIDADES', value: 'total' },
            ],
            
            monthly_headers: [
                { text: 'DT VENC.', value: 'due_date' , sortable: false},
                { text: 'DT PGTO.', value: 'payment_date' , sortable: false},
                { text: 'DT REPASE', value: 'transfer_owner_date' , sortable: false},
                { text: 'TOTAL R$', value: 'total' , sortable: false},
                { text: 'ADM + CREDITOS R$', value: 'adm' , sortable: false},
                { text: 'REPASSE R$', value: 'repasse' , sortable: false},
                { text: 'AÇÕES', value: 'actions', sortable: false }
            ],

            items: [],

            items_alerts:{
                target: [{'value':'owner', 'description':'Locador'}]
            }, 

            show_message: {
                contract_alert: false
            },

            sendItem: null
        }
    },

    methods: {
        rentalMonthlyFeeAlerts(){
            this.$store.dispatch('rentalMonthlyFeeAlerts') 
                        .then(response => {
                            this.alerts = response.data
                        })
        },

        rentalMonthlyFeeAlertReport(params){
            this.show_message.contract_alert = false;
            this.params = params
            this.alert_colors.payment_date_alert = 'white'
            this.alert_colors.transfer_owner_date_alert = 'white'
            this.alert_colors.update_value_alert = 'white'

            if(this.params.payment_date_null){
                this.alert_colors.payment_date_alert = this.alert_selected_color
            }
            if(this.params.transfer_owner_date_null){
                this.alert_colors.transfer_owner_date_alert = this.alert_selected_color
            }
            if(this.params.update_value_yes){
                this.alert_colors.update_value_alert = this.alert_selected_color
            }   

            if(this.params.contract_alert){
                this.show_message.contract_alert = true;
            }
            
            this.$router.push({ 
                name: 'admin.rentals.index', 
                params: this.params
            });
        },

        rentalRentalMonthlyFeeAlertReportExport(params){
            this.$store.dispatch('rentalRentalMonthlyFeeAlertReportExport', params)
        },

        showMonthlyFees(item){
            this.rental_item = item
            this.showDialog('showMonthlyFees')
        },

        showDialog(dialog_name){
            if(dialog_name == 'showMonthlyFees'){
                this.dialog.showMonthlyFees = !this.dialog.showMonthlyFees
            }
            if(dialog_name == 'send_email_contract'){
                this.dialog.send_email_contract = !this.dialog.send_email_contract
            }
        },

        sendAlert(item){
            this.sendItem = item
            this.showDialog('send_email_contract')
        },

        downloadPdfAlert(){
            const params = {};
            params.rental_id = this.sendItem.id
            params.target = ['owner']
            params.file_name = 'alerta_renovacao_' + this.sendItem.codigo + '.pdf' 
            //'rentalLeaseRenewalNoticePdf' 
            this.$store.dispatch('rentalLeaseRenewalNoticePdf', params);
            
        }
    },
    
}
</script>